import { render, staticRenderFns } from "./NewConferenceProduct.vue?vue&type=template&id=395da6b8&scoped=true&"
import script from "./NewConferenceProduct.vue?vue&type=script&lang=js&"
export * from "./NewConferenceProduct.vue?vue&type=script&lang=js&"
import style0 from "./NewConferenceProduct.vue?vue&type=style&index=0&id=395da6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395da6b8",
  null
  
)

export default component.exports